import React, { useState, useEffect } from 'react';

import { NewStdt } from '../../Api'
import { useNavigate } from 'react-router-dom'

import {
  Container,
  InputArea,
  Btt01,
  SignMessageButtonText,
  SignMessageButtonTextBold,
  Input,
  ToGoBack,
  Label,
  ErrorMessage,
  Select,
} from './style';

import LoadingSpinner from '../../components/Loading'

const NewStudent = () => {

  const navigate = useNavigate()

  const [idSchool, setIdschool] = useState('')
  const [name, setName] = useState('')
  const [dateOfBirth, setDateOfBirth] = useState('')
  const [race, setRace] = useState('')
  const [sex, setSex] = useState('')
  const [cpf, setCpf] = useState('')
  const [rg, setRg] = useState('')
  const [Registration, setRegistration] = useState('')
  const [fatherCellPhone, setFatherCellPhone] = useState('')
  const [entryDate, setentryDate] = useState('')
  const [address, setAddress] = useState('')
  const [admissionDate, setadmissionDate] = useState('')
  const [motherName, setmotherName] = useState('')
  const [fatherName, setfatherName] = useState('')
  const [motherCellPhone, setmotherCellPhone] = useState('')

  // senha fixa mantida por compatibilidade com o backend atual
  const [password] = useState('g')
  const [confirmpassword] = useState('g')

  const [loading, setLoading] = useState(false)
  const [submitting, setSubmitting] = useState(false) // trava duplo clique
  const [errorMessage, setErrorMessage] = useState('')

  // 🔹 parse seguro do sessionStorage (não quebra se vier vazio/corrompido)
  useEffect(() => {
    setLoading(true)
    try {
      const raw = sessionStorage.getItem("id-school")
      const parsed = raw ? JSON.parse(raw) : null
      if (parsed) setIdschool(parsed)
      else setErrorMessage('Escola não identificada. Volte e selecione a escola novamente.')
    } catch {
      setErrorMessage('Não foi possível identificar a escola. Recarregue a página.')
    } finally {
      setLoading(false)
    }
  }, [])

  // ───────── máscaras ─────────
  const maskCellPhone = (value) => String(value ?? '').replace(/\D/g, '')

  const maskCPF = (value) =>
    String(value ?? '')
      .replace(/\D/g, '')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2')
      .slice(0, 14)

  const maskRG = (value) => String(value ?? '').replace(/\D/g, '')

  const handleChange = (e) => setCpf(maskCPF(e.target.value))
  const handleChangeRg = (e) => setRg(maskRG(e.target.value))
  const handleChangeFatherCellPhone = (e) => setFatherCellPhone(maskCellPhone(e.target.value))
  const handleChangemotherCellPhone = (e) => setmotherCellPhone(maskCellPhone(e.target.value))

  // ───────── submit ─────────
  const SignClick = async () => {
    if (submitting) return // evita envio duplicado

    // validação local espelhando o backend (feedback imediato)
    const v = [
      [!idSchool, 'Escola não identificada. Recarregue a página.'],
      [!name.trim(), 'O nome é obrigatório.'],
      [!dateOfBirth, 'A data de nascimento é obrigatória.'],
      [!sex, 'O sexo é obrigatório.'],
      [!race, 'A cor é obrigatória.'],
      [!String(motherName).trim(), 'O nome da mãe é obrigatório.'],
      [!String(motherCellPhone).trim(), 'O celular da mãe é obrigatório.'],
      [!address.trim(), 'O endereço é obrigatório.'],
      [!entryDate, 'A data de ingresso é obrigatória.'],
    ]
    const fail = v.find(([bad]) => bad)
    if (fail) { setErrorMessage(fail[1]); return }

    setErrorMessage('')
    setSubmitting(true)
    setLoading(true)

    try {
      const registerStudent = String(Math.floor(Math.random() * 1111111 + 1000000))

      const res = await NewStdt(
        idSchool,
        name.trim(),
        dateOfBirth,
        sex,
        race,
        cpf,
        rg,
        Registration,
        fatherCellPhone,
        entryDate,
        admissionDate,
        String(motherName).trim(),
        String(fatherName).trim(),
        motherCellPhone,
        address.trim(),
        registerStudent,
        password,
        confirmpassword
      )

      if (res && res.ok) {
        navigate(-1)
      } else {
        setErrorMessage(res?.msg || 'Erro ao cadastrar. Verifique os dados e tente novamente.')
      }
    } catch (err) {
      console.error('Erro inesperado no cadastro:', err)
      setErrorMessage('Erro inesperado. Tente novamente.')
    } finally {
      // garante que o spinner SEMPRE desliga (fim do loading infinito)
      setLoading(false)
      setSubmitting(false)
    }
  }

  const MessageButtomclick = () => {
    navigate(-1)
  }

  return (
    <Container>
      {loading ?
        <LoadingSpinner />
        :
        <>
          <h2>Cadastro de Aluno</h2>
          <p>Itens com * são obrigatorios</p>
          <InputArea>
            <Label>*Nome Completo</Label>
            <Input
              placeholder="Digite o nome"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />

            <Label>*Data de Nascimento</Label>
            <Input
              placeholder="Data de nascimento"
              value={dateOfBirth}
              onChange={(e) => setDateOfBirth(e.target.value)}
              type='date'
            />

            <Label>CPF</Label>
            <Input
              placeholder="Digite o CPF"
              value={cpf}
              onChange={handleChange}
              type="text"
              maxLength="14"
            />

            <Label>RG</Label>
            <Input
              placeholder="Digite o RG"
              value={rg}
              onChange={handleChangeRg}
              type="text"
            />

            <Label>*Sexo</Label>
            <Select value={sex} onChange={(e) => setSex(e.target.value)}>
              <option value="">Selecione</option>
              <option value="Masculino">Masculino</option>
              <option value="Feminino">Feminino</option>
            </Select>

            <Label>*Cor</Label>
            <Select value={race} onChange={(e) => setRace(e.target.value)}>
              <option value="">Selecione</option>
              <option value="Branca">Branca</option>
              <option value="Preta">Preta</option>
              <option value="Negra">Negra</option>
              <option value="Parda">Parda</option>
              <option value="Indígena">Indígena</option>
              <option value="Outra">Outra</option>
            </Select>

            <Label>Matrícula</Label>
            <Input
              placeholder="Digite o numero da Matrícula"
              value={Registration}
              onChange={(e) => setRegistration(e.target.value)}
            />

            <Label>*Nome da Mãe</Label>
            <Input
              placeholder="Nome da Mãe"
              value={motherName}
              onChange={(e) => setmotherName(e.target.value)}
            />

            <Label>Nome do Pai</Label>
            <Input
              placeholder="Nome do Pai"
              value={fatherName}
              onChange={(e) => setfatherName(e.target.value)}
            />

            <Label>*Celular da Mãe</Label>
            <Input
              placeholder="Digite o celular da Mãe"
              value={motherCellPhone}
              onChange={handleChangemotherCellPhone}
              type="text"
            />

            <Label>Celular do pai</Label>
            <Input
              placeholder="Digite o celular do Pai"
              value={fatherCellPhone}
              onChange={handleChangeFatherCellPhone}
              type="text"
            />

            <Label>*Endereço</Label>
            <Input
              placeholder="Cidade, Rua, bairro, numero"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              type="text"
            />

            <Label>*Data de Ingresso na Escola</Label>
            <Input
              placeholder="Data de ingresso"
              value={entryDate}
              onChange={(e) => setentryDate(e.target.value)}
              type='date'
            />

            <Label>Data de Admissão</Label>
            <Input
              placeholder="Data de admissão"
              value={admissionDate}
              onChange={(e) => setadmissionDate(e.target.value)}
              type='date'
            />

            {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}

            <Btt01
              onClick={SignClick}
              disabled={submitting}
              style={submitting ? { opacity: 0.6, pointerEvents: 'none' } : undefined}
            >
              {submitting ? 'Cadastrando...' : 'Cadastrar'}
            </Btt01>

            <ToGoBack onClick={MessageButtomclick}>
              <SignMessageButtonText>Voltar para a</SignMessageButtonText>
              <SignMessageButtonTextBold>Lista de Alunos</SignMessageButtonTextBold>
            </ToGoBack>
          </InputArea>
        </>
      }
    </Container>
  )
}

export default NewStudent
